import React from 'react';

const Button = ({ className = 'option-menu', name = 'OK', onClick = () => { }, type = "button" }) => {
    return <button type={type} onClick={onClick} className={`button__${className} button`}>{name}</button>
}

export default Button